import TextInput from '../../../../atoms/inputs/text-input';
import {
  InlineEditableInputWrapper,
  type InlineEditableInputWrapperProps,
} from '../inline-editable-input-wrapper';
import { getInlineInputRemPadding } from '../../../../atoms/buttons/button/button.styles';

interface InlineTextInputProps
  extends Omit<InlineEditableInputWrapperProps, 'children'> {
  placeholder?: string;
}

export const InlineTextInput: React.FC<InlineTextInputProps> = ({
  placeholder,
  size = 'sm',
  ...props
}) => {
  const inlineInputPadding = getInlineInputRemPadding(size);

  return (
    <InlineEditableInputWrapper {...props} size={size}>
      {({ value, onChange, disabled }) => (
        <TextInput
          className="w-full"
          style={{ paddingRight: `${inlineInputPadding}rem` }}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder ?? props.label}
          size={size}
          shadow="inset-sm"
          disabled={disabled}
        />
      )}
    </InlineEditableInputWrapper>
  );
};
